import { connect } from 'react-redux'
import Age from './Age.jsx'
import {
    getCollaborativeIndexationCreationFields,
    isCollaborativeIndexationCreationInvalidField,
} from '../../../../../../redux/collaborativeIndexations/selectors'
import {
    resetCollaborativeIndexationCreationInvalidField,
    updateCollaborativeIndexationFieldValue,
} from '../../../../../../redux/collaborativeIndexations/actions'

const mapDispatchToProps = dispatch => ({
    updateFieldValue: (field, value) => dispatch(updateCollaborativeIndexationFieldValue(field, value)),
    resetInvalidField: field => dispatch(resetCollaborativeIndexationCreationInvalidField(field))
})

const mapStateToProps = state => ({
    fields: getCollaborativeIndexationCreationFields(state),
    isInvalidField: field => isCollaborativeIndexationCreationInvalidField(state, field),
})

export const AgeContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Age)
